import { render, staticRenderFns } from "./LsFeedbackText.vue?vue&type=template&id=7a51b08a&scoped=true&"
import script from "./LsFeedbackText.vue?vue&type=script&lang=js&"
export * from "./LsFeedbackText.vue?vue&type=script&lang=js&"
import style0 from "./LsFeedbackText.vue?vue&type=style&index=0&id=7a51b08a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a51b08a",
  null
  
)

export default component.exports